$(function() {

	// Auto focus
	$('form.autofocus input:visible:first').filter(function() { return $(this).val() == ""; }).focus();

	// Nested checkboxes
	$('.nested-checkboxes').disableSelection();
	$('.nested-checkboxes input').change(function() {
		var sibling = $(this).closest('.checkbox').siblings('.checkbox-child');
		sibling[$(this).prop('checked') ? 'addClass' : 'removeClass']('visible');
		sibling.find('input').prop('checked', false);
	});

});

(function($){
    $.fn.disableSelection = function() {
        return this
                 .attr('unselectable', 'on')
                 .css('user-select', 'none')
                 .on('selectstart', false);
    };
})(jQuery);